<template>
    <div class="container text-center pluginHome home-gallery">
        <h1 class="heading">v-uploader</h1>

        <p align="center">
            <gh-btn class="me-2" href="https://github.com/terryz/v-uploader" data-icon="octicon-star" data-show-count="true" aria-label="Star terryz/v-uploader on GitHub">Star</gh-btn>
            <gh-btn href="https://github.com/terryz/v-uploader/fork" data-icon="octicon-repo-forked" data-show-count="true" aria-label="Fork terryz/v-uploader on GitHub">Fork</gh-btn>
        </p>

        <p align="center" class="gallery-container">
            <v-gallery type="carousel" :images="list" ></v-gallery>
        </p>

        <p><i18n path="upload.projectDesc"></i18n></p>

        <p>
            <a href="https://www.npmjs.com/package/v-uploader" target="_blank" class="me-2">
                <img src="https://img.shields.io/npm/v/v-uploader.svg" alt="v-uploader-npm">
            </a>
            <a href="https://mit-license.org/" target="_blank">
                <img src="https://img.shields.io/badge/license-MIT-brightgreen.svg" alt="v-page-npm">
            </a>
        </p>
    </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        {
          title: 'Single file upload with preview',
          url: `${this.$store.state.baseImgUrl}/image/v-uploader/v-uploader-single.png`
        }, {
          title: 'Multiple files upload with file drag',
          url: `${this.$store.state.baseImgUrl}/image/v-uploader/v-uploader-multiple.png`
        }
      ]
    }
  }
}
</script>
